export default __webpack_public_path__ + "static/media/evolvingCredibility.69a91e9c.svg";